<template>
  <teleport to="body">
    <div
      v-if="modelValue"
      class="modal-overlay"
      role="dialog"
      aria-modal="true"
      @click.self="close"
    >
      <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Share Album</h5>
          <button type="button" class="close" aria-label="Close" @click="close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <!-- Add People -->
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="mb-0">Add People</h6>
            <button class="btn btn-outline-primary btn-sm" @click="toggleAddPeople">
              <i class="fas fa-user-plus mr-1"></i>
              {{ showAddPeople ? 'Hide' : 'Add People' }}
            </button>
          </div>

          <div v-if="showAddPeople">
            <div v-if="loadingAddPeople" class="text-center py-3">
              <div class="spinner-border text-primary"></div>
            </div>
            <ul v-else class="list-group">
              <li
                v-for="f in addPeopleFriends"
                :key="getUserId(f)"
                class="list-group-item d-flex align-items-center justify-content-between"
              >
                <div class="d-flex align-items-center">
                  <img
                    :src="f.user_img || 'https://dummyimage.com/60x60/ddd/555.png&text=F'"
                    class="rounded mr-2"
                    style="width:36px;height:36px;object-fit:cover"
                    alt=""
                  />
                  <div>
                    <div class="font-weight-bold">{{ f.name || f.username || f.display_name || 'User' }}</div>
                    <div class="text-muted small">{{ f.email || '' }}</div>
                    <p class="small" v-if="f.invite_send_status === 1">Already Invite Added</p>
                    <p class="small" v-else-if="f.access_send_status === 1">Photos shared</p>
                  </div>
                </div>
                <button
                  class="btn btn-sm"
                  v-if="f.invite_send_status === 0 && f.access_send_status == 0"
                  :class="selectedIds.has(getUserId(f)) ? 'btn-danger' : 'btn-outline-primary'"
                  :disabled="saving"
                  @click="togglePick(f)"
                >
                  <i :class="selectedIds.has(getUserId(f)) ? 'fas fa-minus mr-1' : 'fas fa-plus mr-1'"></i>
                  {{ selectedIds.has(getUserId(f)) ? 'Remove' : 'Add' }}
                </button>
              </li>
            </ul>
          </div>

          <!-- Tabs -->
          <div class="tabset" role="tablist" aria-label="Share tabs" v-if="!showAddPeople">
            <button type="button" class="tab-btn" :class="{ active: tab==='friends' }" @click="switchTab('friends')">My Friends</button>
            <button type="button" class="tab-btn" :class="{ active: tab==='guests' }" @click="switchTab('guests')">Guests</button>
            <button type="button" class="tab-btn" :class="{ active: tab==='scanned' }" @click="switchTab('scanned')">Scanned</button>
          </div>

          <div v-show="!showAddPeople && tab==='friends'">
            <div v-if="loadingFriends" class="text-center py-3"><div class="spinner-border text-primary"></div></div>
            <ul v-else class="list-group">
              <li v-for="u in friends" :key="getUserId(u)" class="list-group-item d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <img
                    :src="u.user_img || 'https://dummyimage.com/60x60/ddd/555.png&text=G'"
                    class="rounded mr-2"
                    style="width:36px;height:36px;object-fit:cover"
                    alt=""
                  />
                  <div>
                    <div class="font-weight-bold">{{ u.name || 'User' }}</div>
                    <div class="text-muted small">{{ u.username || '' }}</div>
                  </div>
                </div>
                <button
                  class="btn btn-sm btn-outline-danger p-2"
                  :disabled="removingId === getUserId(u)"
                  @click="removeFriend(u)"
                  title="Remove friend"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </li>
            </ul>
          </div>

          <div v-show="!showAddPeople && tab==='guests'">
            <div v-if="loadingGuests" class="text-center py-3"><div class="spinner-border text-primary"></div></div>
            <ul v-else class="list-group">
              <li v-for="u in guests" :key="getUserId(u)" class="list-group-item d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <img
                    :src="u.user_img || 'https://dummyimage.com/60x60/ddd/555.png&text=G'"
                    class="rounded mr-2"
                    style="width:36px;height:36px;object-fit:cover"
                    alt=""
                  />
                  <div>
                    <div class="font-weight-bold">{{ u.name || 'User' }}</div>
                    <div class="text-muted small">{{ u.username || '' }}</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div v-show="!showAddPeople && tab==='scanned'">
            <div v-if="loadingScanned" class="text-center py-3"><div class="spinner-border text-primary"></div></div>
            <ul v-else class="list-group">
              <li v-for="u in scanned" :key="getUserId(u)" class="list-group-item d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <img
                    :src="u.user_img || 'https://dummyimage.com/60x60/ddd/555.png&text=G'"
                    class="rounded mr-2"
                    style="width:36px;height:36px;object-fit:cover"
                    alt=""
                  />
                  <div>
                    <div class="font-weight-bold">{{ u.name || 'User' }}</div>
                    <div class="text-muted small">{{ u.username || '' }}</div>
                  </div>
                </div>
                <span class="badge badge-light">Scanned</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" :disabled="saving" @click="close">Close</button>
          <button class="btn btn-primary" v-if="showAddPeople" :disabled="saving || selectedIds.size===0" @click="saveAddPeople">
            <span v-if="!saving">Save</span>
            <span v-else><span class="spinner-border spinner-border-sm mr-1"></span>Saving…</span>
          </button>
        </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
/* eslint-env vue/setup-compiler-macros */
import { ref, watch } from 'vue'
import api from '@/services/api'

const props = defineProps({
  modelValue: { type: Boolean, default: false }, // v-model
  eventId: { type: [String, Number], required: true },
  sessionUserId: { type: [String, Number], required: true }
})
const emit = defineEmits(['update:modelValue'])

function close(){ emit('update:modelValue', false) }

/* tabs */
const tab = ref('friends')
const loadingFriends = ref(false)
const loadingGuests  = ref(false)
const loadingScanned = ref(false)
const friends = ref([])
const guests  = ref([])
const scanned = ref([])

/* Add people */
const showAddPeople = ref(false)
const loadingAddPeople = ref(false)
const addPeopleFriends = ref([])
const selectedIds = ref(new Set())
const saving = ref(false)
const removingId = ref('')

function getUserId(u){
  return String(u?.id ?? u?.user_id ?? u?.guest_id ?? u?.contact_id ?? u?.uid ?? '')
}

function switchTab(t){
  if (tab.value === t) return
  tab.value = t
  loadTab(t)
}

function toggleAddPeople(){
  showAddPeople.value = !showAddPeople.value
  if (showAddPeople.value) loadFriendsForAddPeople()
}

async function loadFriendsForAddPeople(){
  try {
    loadingAddPeople.value = true
    const fd = new FormData()
    fd.append('userid', String(props.sessionUserId))
    fd.append('eventid', String(props.eventId))
    const res = await api.getMyFriends(fd)
    const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
    addPeopleFriends.value = ok ? (res.data?.data || res.data || []) : []
  } catch (e) {
    console.error('loadFriendsForAddPeople error:', e)
    addPeopleFriends.value = []
  } finally {
    loadingAddPeople.value = false
  }
}

function togglePick(u){
  const id = getUserId(u)
  const s = new Set(selectedIds.value)
  if (s.has(id)) s.delete(id); else s.add(id)
  selectedIds.value = s
}

async function saveAddPeople(){
  try {
    saving.value = true
    const ids = Array.from(selectedIds.value)
    if (!ids.length) return
    const fd = new FormData()
    fd.append('fromuserid', String(props.sessionUserId))
    fd.append('eventid', String(props.eventId))
    fd.append('touserid', ids.join(','))
    const res = await api.saveAlbumAcess(fd)
    const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
    if (!ok) throw new Error('saveAlbumAcess failed')
    showAddPeople.value = false
    selectedIds.value = new Set()
    await loadTab(tab.value)
  } catch (e) {
    console.error('saveAddPeople error:', e)
    alert('Could not save selected friends.')
  } finally {
    saving.value = false
  }
}

async function removeFriend(u){
  try {
    const id = getUserId(u)
    if (!id) return
    if (!confirm('Remove this friend?')) return
    removingId.value = id

    const fd = new FormData()
    fd.append('fromuserid', String(props.sessionUserId))
    fd.append('touserid', id)
    fd.append('eventid', String(props.eventId))
    const res = await api.removeAlbumFriend(fd)
    const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
    if (!ok) throw new Error('removeAlbumFriend failed')
    friends.value = friends.value.filter(x => getUserId(x) !== id)
  } catch (e) {
    console.error('removeFriend error:', e)
    alert('Could not remove friend.')
  } finally {
    removingId.value = ''
  }
}

async function loadTab(t){
  const fd = new FormData()
  fd.append('userid', String(props.sessionUserId))
  fd.append('user_id', String(props.sessionUserId))
  fd.append('eventid', String(props.eventId))
  fd.append('event_id', String(props.eventId))

  if (t === 'friends') {
    try {
      fd.append('type', 'app')
      loadingFriends.value = true
      const res = await api.getScannedGuests(fd)
      const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
      friends.value = ok ? (res.data?.data || res.data || []) : []
    } catch (e) {
      console.error('friends tab error:', e)
      friends.value = []
    } finally {
      loadingFriends.value = false
    }
  } else if (t === 'guests') {
    try {
      loadingGuests.value = true
      const res = await api.getInvitationDetail(fd)
      const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
      guests.value = ok ? (res.data?.data || res.data || []) : []
    } catch (e) {
      console.error('guests tab error:', e)
      guests.value = []
    } finally {
      loadingGuests.value = false
    }
  } else {
    try {
      fd.append('type', 'scanned')
      loadingScanned.value = true
      const res = await api.getScannedGuests(fd)
      const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
      scanned.value = ok ? (res.data?.data || res.data || []) : []
    } catch (e) {
      console.error('scanned tab error:', e)
      scanned.value = []
    } finally {
      loadingScanned.value = false
    }
  }
}

watch(()=>props.modelValue,(open)=>{
  if (open) { tab.value = 'friends'; showAddPeople.value = false; selectedIds.value = new Set(); loadTab('friends') }
})
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  z-index: 1050;
  overflow-y: auto;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 760px;
}

.modal-content {
  border: none;
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.25);
}

.modal-header,
.modal-footer {
  border-color: rgba(15, 23, 42, 0.08);
}

@media (max-width: 768px) {
  .modal-overlay {
    padding: 1rem;
  }
  .modal-dialog {
    max-width: 100%;
  }
}
</style>
